module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/RUTH_contents"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("av")]), _vm._v(" – The Authorized (King James) Version of the Bible, 1611.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Cooke – G. A. Cooke, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ruth")]), _vm._v(" ("), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The Cambridge Bible")]), _vm._v(", CUP, 1918).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Eichrodt – W. Eichrodt, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology of the Old Testament")]), _vm._v(", 1 (ET, SCM Press, 1961).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("jb")]), _vm._v(" – The Jerusalem Bible (Darton, Longman and Todd, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Keil–Delitzsch – C. F. Keil and F. Delitzsch, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblical Commentary on the Old Testament: Ruth")]), _vm._v(" (ET, Eerdmans, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Knight – G. A. Knight, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ruth and Jonah")]), _vm._v(" ("), _c('span', {
    staticClass: "roman"
  }, [_vm._v("Torch Bible Commentaries")]), _vm._v(", SCM Press, 1950).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Knox – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Testament of Our Lord and Saviour Jesus Christ")]), _c('span', {
    staticClass: "roman"
  }, [_vm._v(",")]), _vm._v(" translated by Ronald Knox (Burns, Oates and Washbourne, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Leggett – D. A. Leggett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Levirate and Goel Institutions in the Old Testament")]), _vm._v(" (Mack, NJ, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Moffatt – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Testament: A New Translation")]), _vm._v(" by James Moffatt (Hodder and Stoughton, revised edition, 1935).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Morris – A. E. Cundall and L. Morris, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Judges and Ruth")]), _vm._v(" ("), _c('span', {
    staticClass: "roman"
  }, [_vm._v("Tyndale Old Testament Commentaries")]), _vm._v(", Inter-Varsity Press, 1968).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("neb")]), _vm._v(" – The New English Bible (NT 1961, "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("2nd edition ")]), _vm._v("1970; OT 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("niv")]), _vm._v(" – The New International Version of the Bible (Hodder and Stoughton, 1979, 1984, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("nrsv")]), _vm._v(" – The New Revised Standard Version of the Bible (NT 1946, "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("2nd edition ")]), _vm._v("1971; OT 1952; 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Rowley – H. H. Rowley, ‘The Marriage of Ruth’, in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Servant of the Lord and Other Essays")]), _vm._v(" (Blackwell, "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("2nd edition ")]), _vm._v("1965).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("rsv")]), _vm._v(" – The Revised Standard Version of the Bible (NT 1946, "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("2nd edition ")]), _vm._v("1971; OT 1952).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("de Vaux – Roland de Vaux, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ancient Israel")]), _vm._v(" (Darton, Longman and Todd, "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("3rd edition ")]), _vm._v("1973).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1453031a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/RUTH_abbrev.vue
// module id = 75
// module chunks = 0